export default {
  data() {
    return {
      // 0-普通附件; 1-固件附件; 2:日志附件; 3-问题附件;
      attachTypeList: [
        { label: this.$t('attach_form_attach_type_normal'), value: 0 },
        { label: this.$t('attach_form_attach_type_firmware'), value: 1 },
        { label: this.$t('attach_form_attach_type_log'), value: 2 },
        { label: this.$t('attach_form_attach_type_issue'), value: 3 },
      ],

      // 上传的文件类型
      // 支持: .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt, .zip, .rar, .7z. 不超过 100 MB(1G=1024MB)
      // icon值 前端写死，map到数据保存，所以前端的icon value值不可随意更改
      fileTypeList: {
        word: {
          suffix: ['.doc', '.docx'],
          value: 1,
          icon: 'file-icon-word',
        },
        excel: {
          suffix: ['.xls', '.xlsx'],
          value: 2,
          icon: 'file-icon-excel',
        },
        ppt: {
          suffix: ['.ppt', '.pptx'],
          value: 3,
          icon: 'file-icon-ppt',
        },
        pdf: {
          suffix: ['.pdf'],
          value: 4,
          icon: 'file-icon-pdf',
        },
        txt: {
          suffix: ['.txt'],
          value: 5,
          icon: 'file-icon-txt',
        },
        zip: {
          suffix: ['.zip'],
          value: 6,
          icon: 'file-icon-zip',
        },
        rar: {
          suffix: ['.rar'],
          value: 7,
          icon: 'file-icon-rar',
        },
        '7z': {
          suffix: ['.7z'],
          value: 8,
          icon: 'file-icon-7z',
        },
      },

      // 读权限列表
      readList: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
      ],
      // 写权限列表
      writeList: [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
      ],
    };
  },

  methods: {
    // 获取文件类型
    getFileType(suffix) {
      let fileType = null;
      for (const key in this.fileTypeList) {
        if (this.fileTypeList[key].suffix.includes(suffix)) {
          fileType = this.fileTypeList[key];
          break;
        }
      }
      return fileType;
    },
  },
};
